export const isIncludeHankoVisible = (isLocalisedSignature: boolean) => isLocalisedSignature;
